import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";
import EtsyPage from "@/pages/EtsyPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <div className="noise-overlay" />
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/shop" element={<EtsyPage />} />
          <Route path="/etsy" element={<EtsyPage />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
        <Footer />
        <Toaster 
          position="bottom-right"
          toastOptions={{
            style: {
              background: '#000',
              color: '#fff',
              border: '4px solid #00c9b0',
              fontFamily: "'Space Mono', monospace",
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
